import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, XCircle, RotateCcw, Headphones } from "lucide-react";

/* ===================== STYLES ===================== */
import styles from "./PaymentFailed.module.scss";

const PaymentFailed = () => {
  const { state } = useLocation();

  // Extract error message from state, fallback to default
  const errorMessage =
    state?.errorMessage || "Your payment could not be processed successfully.";

  return (
    <div className={styles["admin-pay-failed__page"]}>
      {/* BACK NAVIGATION */}
      <div className={styles["admin-pay-failed__header"]}>
        <Link
          to="/billing"
          className={styles["admin-pay-failed__back-btn"]}
          aria-label="Go back to billing"
        >
          <ArrowLeft size={20} strokeWidth={2.5} />
        </Link>
      </div>

      {/* MAIN CARD */}
      <div className={styles["admin-pay-failed__card"]}>
        <div className={styles["admin-pay-failed__icon-wrapper"]}>
          <XCircle size={40} strokeWidth={2.5} />
        </div>

        <h1 className={styles["admin-pay-failed__title"]}>Payment Failed</h1>

        <p className={styles["admin-pay-failed__subtitle"]}>
          We couldn't process your payment. No charges were made to your
          account.
        </p>

        {/* DYNAMIC ERROR MESSAGE FROM API */}
        <div className={styles["admin-pay-failed__error-block"]}>
          {errorMessage}
        </div>

        {/* ACTIONS */}
        <div className={styles["admin-pay-failed__actions"]}>
          <Link
            to="/billing/pricing"
            className={`${styles["admin-pay-failed__btn"]} ${styles["admin-pay-failed__btn--primary"]}`}
          >
            <RotateCcw size={18} strokeWidth={2.5} />
            Try Again
          </Link>

          <Link
            to="/contact"
            className={`${styles["admin-pay-failed__btn"]} ${styles["admin-pay-failed__btn--secondary"]}`}
          >
            <Headphones size={18} strokeWidth={2.5} />
            Contact Support
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
